// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2k4R2","title":"Header_title__2vDhN","left":"Header_left__RkPVb","clinicName":"Header_clinicName__3Zwwt"};